<template>
    <div class="form-item">
        <label class="label-caption">Unidade</label>
        <select :value="unidadeSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        unidadeSelecionada: {type: String, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 'KG', descricao: 'QUILO' },
                { id: 'LT', descricao: 'LITROS' },
                { id: 'DZ', descricao: 'DÚZIA' },
                { id: 'UN', descricao: 'UNIDADE' },
                { id: 'TN', descricao: 'TONELADA' },
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: '.', descricao: 'TODAS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:unidadeSelecionada', event.target.value);
        }
    }
};
</script>